export default __webpack_public_path__ + "76b8cf4e3bdf08152a78100a637b9972.svg";